import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const auditInfo = async (data: object) => {
  return await POST({
    url: Api.auditInfo,
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    showError: false
  })
}

export const upload = async (data: object) => {
  return await POST({
    url: Api.upload,
    data,
    showError: false
  })
}
